/* eslint-disable max-len */
import React, { useState, useEffect, useRef } from 'react';
import { object } from 'prop-types';
import { connect, useSelector } from 'react-redux';
import get from 'lodash/get';
import AdvancesDeclinesWidget from '../../pages/markets/component/advances-declines';
import ResearchReports from '../../pages/markets/component/research-reports';
import WidgetMarketNews from '../markets-news-widget/markets-news';
import MoreFromMarkets from '../../pages/markets/component/more-from-markets';
import TopSectors from '../../pages/markets/component/top-sectors';
import CalendarEvents from '../../pages/markets/component/calendar-events';
import FuturesGraphMobile from '../../pages/markets/component/futures-graph-mobile';
import IndianIndices from '../../pages/markets/component/indian-indices';
import SectoralIndices from '../../pages/markets/component/sectoral-indices';
import StockStatistics from '../../pages/markets/component/stock-statistics';
import { QueryClient, QueryClientProvider } from 'react-query';
import InfiniteStoryWithHeading from '../../molecules/infinite-story-with-heading';
import { WithLazy } from '@quintype/components';
import { scroller } from 'react-scroll';
import { makeApiCall } from '../../../helpers/utils';
import './markets-full.m.css';
import BudgetStocksInFocusHorizontal from '../../collection-templates/budget-stocks-in-focus-horizontal';

const MarketPageBase = (props) => {
  const [marketNews, setMarketNews] = useState([]);
  const queryClient = new QueryClient();
  const [isLoading, setIsLoading] = useState(false);
  const moreNewsRef = useRef();
  const NDTV_SEARCH_API_CONFIG = useSelector((state) =>
    get(state, ['qt', 'config', 'integrations', 'aiSummary'], {}),
  );
  const hide_components = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'budget', 'hide_components'], {}),
  );
  const budget_hide_components =
    hide_components?.enabled &&
    hide_components?.timestamp === new Date().toISOString().split('T')[0];

  useEffect(() => {
    makeApiCall(
      `${NDTV_SEARCH_API_CONFIG?.url}${NDTV_SEARCH_API_CONFIG?.client_key}${NDTV_SEARCH_API_CONFIG?.story_params}&pagesize=5&${NDTV_SEARCH_API_CONFIG?.markets_param}`,
    ).then((res) => {
      setMarketNews(res?.results || []);
    });
  }, []);

  const scrollToMoreNews = () => {
    if (moreNewsRef?.current) {
      scroller.scrollTo(moreNewsRef?.current?.id, {
        duration: 500,
        smooth: true,
        offset: -70,
      });
    }
  };

  if (props.data.query) {
    return <InfiniteStoryWithHeading {...props} />;
  }
  return (
    <QueryClientProvider client={queryClient}>
      <>
        <div
          styleName={`background-container ${!budget_hide_components ? 'non-budget-day-bg' : ''}`}
        >
          <div styleName="market-page" className="container">
            <div styleName="first-fold-top">
              <div
                className="sidebar row-section"
                styleName={`${budget_hide_components ? 'budget-day' : 'non-budget-day'}`}
              >
                <WidgetMarketNews
                  newsData={marketNews}
                  loadingStatus={isLoading}
                  moreRef={scrollToMoreNews}
                />
                <IndianIndices
                  widget={true}
                  container={'full'}
                  budget_hide_components={budget_hide_components}
                />
              </div>
            </div>
          </div>
        </div>

        <div styleName="market-page" className="container">
          <div styleName="first-fold" className="mobile-only">
            <div className="sidebar row-section">
              <IndianIndices
                widget={true}
                container={'full'}
                budget_hide_components={budget_hide_components}
              />
              <WidgetMarketNews
                newsData={marketNews}
                loadingStatus={isLoading}
                moreRef={scrollToMoreNews}
              />
            </div>
          </div>

          <div styleName="second-content-fold">
            <div className="sidebar row-section">
              <ResearchReports widget={true} />
            </div>

            <div className="sidebar row-section">
              {!budget_hide_components ? (
                <StockStatistics widget={true} />
              ) : (
                <BudgetStocksInFocusHorizontal
                  widget={true}
                  limit={'10'}
                  customClass={'budget-bg'}
                />
              )}

              <div styleName="futures-subscriptions-container">
                <FuturesGraphMobile flag="homepage" widget={true} container={'full'} />
              </div>
            </div>

            <div className="sidebar row-section" id="more-from-markets" ref={moreNewsRef}>
              <MoreFromMarkets newsData={marketNews} />
              {!budget_hide_components && <AdvancesDeclinesWidget widget={true} />}
            </div>
          </div>
        </div>

        <div styleName="background-container">
          <div styleName="market-page" className="container">
            <div styleName="second-content-fold">
              <div className="sidebar row-section">
                {!budget_hide_components ? (
                  <WithLazy>{() => <SectoralIndices widget={true} />}</WithLazy>
                ) : (
                  <WithLazy>
                    {() => <CalendarEvents widget={true} customClass={'budget-bg'} />}
                  </WithLazy>
                )}
              </div>
            </div>
          </div>
        </div>

        {!budget_hide_components && (
          <div styleName="market-page" className="container">
            <WithLazy>
              {() => (
                <div styleName="first-fold">
                  <div className="sidebar row-section">
                    <TopSectors widget={true} container={'full'} />
                    <CalendarEvents widget={true} container={'full'} />
                  </div>
                </div>
              )}
            </WithLazy>
          </div>
        )}
      </>
    </QueryClientProvider>
  );
};

MarketPageBase.propTypes = {
  config: object,
  data: object,
};

const mapStateToProps = (state) => ({
  config: get(state.qt, ['config'], {}),
});

const MarketsFull = connect(mapStateToProps, {})(MarketPageBase);

export default MarketsFull;
